export default {
    data: [],
    isLoading: false,
    error: null
}